import { IconButton } from "@carbon6/c6-frontend-design";
import type { MouseEvent as ReactMouseEvent, ReactNode } from "react";
import { BookmarkStarButton } from "@/components/buttons";
import { DisabledReasonTooltip, HatTextTooltip } from "@/components/tooltip";
import styles from "./DatasetCardRowActions.module.css";

export type DatasetCardBookmarkAction = {
  // 이미 북마크에 담긴 dataset 이면 채운 금색 별 + selected 로 표시한다. 북마크 탭에서는 이 별을
  // 눌러 뺀다. 어느 목록에서든 별 하나가 담기/빼기 토글이다.
  isAdded: boolean;
  disabled: boolean;
  // hover 툴팁 문구(상태에 따라 "북마크에 담기"/"담는 중…"/"북마크에 있음").
  tooltip: string;
  onPress: () => void;
};

export type DatasetCardTrainAction = {
  onPress: () => void;
  // 값이 있으면 버튼을 끄고 이 문장을 툴팁으로 표시한다. 예) 저장 위치가 학습을 지원하지 않는다.
  disabledReason?: string;
};

export type DatasetCardRowActionsProps = {
  // 지정하지 않으면(권한 없음, archived) 학습 버튼을 그리지 않는다. 게이트 판정은 호출부가 소유한다.
  train?: DatasetCardTrainAction;
  bookmark: DatasetCardBookmarkAction;
};

// 공용 데이터셋 카드·행의 인라인 액션. 더보기 메뉴 대신 학습(텍스트)·별(북마크 담기/빼기)
// IconButton 을 직접 표시한다. 가용·보관됨·북마크 세 목록의 모양이 같다. hover 하면
// HatTextTooltip 으로 상태 문구를 표시한다.
export function DatasetCardRowActions({ train, bookmark }: DatasetCardRowActionsProps): ReactNode {
  return (
    <span className={styles.actions}>
      {train === undefined ? null : train.disabledReason === undefined ? (
        <HatTextTooltip text="이 Dataset으로 새 Training을 시작합니다.">
          <IconButton
            text="Training"
            size="sm"
            variant="surface"
            onClick={(event) => runAction(event, train.onPress)}
          />
        </HatTextTooltip>
      ) : (
        <DisabledReasonTooltip text={train.disabledReason}>
          <IconButton text="Training" size="sm" variant="surface" disabled />
        </DisabledReasonTooltip>
      )}
      <HatTextTooltip text={bookmark.tooltip}>
        <BookmarkStarButton
          aria-label={bookmark.tooltip}
          size="sm"
          added={bookmark.isAdded}
          disabled={bookmark.disabled}
          onClick={(event) => runAction(event, bookmark.onPress)}
        />
      </HatTextTooltip>
    </span>
  );
}

// 카드·행 클릭(상세 열기)으로 이벤트가 버블링되지 않게 막고 액션만 실행한다.
function runAction(event: ReactMouseEvent<HTMLButtonElement>, onPress: () => void): void {
  event.stopPropagation();
  onPress();
}
